import {useEffect, useState} from 'react';

export function useDebounce(value, debounceTime = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, debounceTime);

    return () => clearTimeout(timer);
  }, [value]);

  return debouncedValue;
}